import { actionType } from './actions';

const initialState = {
    addNewClientData: {
        name: '',
        contactName: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
        countryId: '',
        serviceFee: '',
        otherFee: '',
        priorityServiceFee: ''
    },
    editClientData: {
        clientId: '',
        name: '',
        contactName: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
        countryId: '',
        serviceFee: '',
        otherFee: '',
        priorityServiceFee: ''
    },
    viewClientData: {
        clientId: '',
        name: '',
        contactName: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
        countryId: '',
        countryName: '',
        serviceFee: '',
        otherFee: '',
        priorityServiceFee: ''
    },
    clients: [],
    clientSearchResults: [],
    searchString: '',
    selectedItemData: {},
    isGridItemSelected: false,
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_CLIENT_INFORMATION_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.ADD_NEW_CLIENT:
        case actionType.EDIT_CLIENT: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.REJECTED_CLIENT_INFORMATION_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_CLIENT_INFO: {
            return {
                ...state,
                editClientData: action.payload,
                viewClientData: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_ALL_CLIENT_DATA: {
            return {
                ...state,
                clients: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.SEARCH_CLIENT_BY_KEYWORD: {
            return {
                ...state,
                clientSearchResults: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_CLIENTS_BY_ACCOUNT: {
            return {
                ...state,
                clients: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.UPDATE_CLIENT_SELECTED: {
            return {
                ...state,
                selectedItemData: action.payload
            };
        }

        case actionType.UPDATE_SEARCH_STRING: {
            return {
                ...state,
                searchString: action.payload
            };
        }

        case actionType.UPDATE_ADD_NEW_CLIENT_PAYLOAD: {
            return {
                ...state,
                addNewClientData: action.payload
            };
        }

        case actionType.UPDATE_EDIT_CLIENT_PAYLOAD: {
            return {
                ...state,
                editClientData: action.payload
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/clientInformation/reducers.js